import { render, staticRenderFns } from "./serchTableList.vue?vue&type=template&id=2d06c39e&scoped=true"
import script from "./serchTableList.vue?vue&type=script&lang=js"
export * from "./serchTableList.vue?vue&type=script&lang=js"
import style0 from "./serchTableList.vue?vue&type=style&index=0&id=2d06c39e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06c39e",
  null
  
)

export default component.exports